import { Text } from '@wix/design-system'
import React, { ComponentProps, FC, memo } from 'react'
import sanitizeHtml, { IOptions as SanitizerOptions } from 'sanitize-html'

type RichTextProps = ComponentProps<typeof Text> & {
  children?: string
  color?: string
}

const sanitizerOptions: SanitizerOptions = {
  allowedTags: ['b', 'br', 'p', 'ul', 'li', 'a', 'u'],
  allowedAttributes: { a: ['href', 'target', 'rel'] },
}

export const RichText: FC<RichTextProps> = memo(({ children, color, ...props }) => {
  const sanitizedHtml = sanitizeHtml((children || '').replace(/\n/g, ''), sanitizerOptions)

  return (
    <Text {...props} tagName="div">
      <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} style={{ color }} />
    </Text>
  )
})
